<template>
  <div id="recharge">
    <div @click="back" class="header border-bottom">
      <i class="iconfont">&#xe604;</i>
    </div>
    <div class="content">
      <div class="wechat_pay">
        <i class="iconfont">&#xe696;</i>
        <div>
          <p>微信支付</p>
          <p>每次可充值1元到1万元之间的整数金额</p>
        </div>
      </div>
      <div class="recharge">
        <p>充值金额</p>
        <div class="content-price border-bottom">
          <span>￥</span>
          <input type="number" placeholder="请输入充值金额" v-model="price">
        </div>
      </div>
    </div>
    <div class="footer">
      <button name="submit" type="submit" @click="handleRechargeClick">{{state}}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RechargeMess',
  data () {
    return {
      state: '使用微信充值',
      price: ''
    }
  },
  methods: {
    back () {
      this.$router.go(-1) // 返回上一层
    },
    handleRechargeClick (res) {
      if (!res.errorInfo) {
        this.$router.push({
          path: '/wechat_pay',
          query: {
            amount: this.price
          }
        })
      } else {
        alert(res.errorInfo)
      }
    }
  }
}
</script>

<style scoped>
#recharge{ min-height: 100%;}
.header{ display: flex; justify-content: space-between; align-items: center; padding: 10px 15px;}
.header .iconfont{ font-size: 25px;}
.content{ padding: 10px 15px;}
.wechat_pay{ display: flex; align-items: center; margin: 0 auto; background: #f7f7f7; padding: 15px;}
.wechat_pay .iconfont{ color: #3eaf38; font-size: 30px;}
.wechat_pay p{ margin-left: 10px; color: #666; line-height: 22px;}
.wechat_pay p:first-child{ color: #3eaf38;}
.recharge span{ color: #999;}
.recharge p{ margin: 15px 0;}
.content-price span{ font-size: 25px; font-weight: bold; color: #333;}
.content-price input{ border: 0; height: 30px; font-size: 20px; padding-bottom: 10px;}
input::-webkit-input-placeholder{ color:#bdbdbd; font-size: 14px; font-weight: normal; line-height: 20px; padding-left: 5px; font-family: Arial,"Microsoft YaHei";}
.money{ display: flex; flex-wrap: wrap; text-align: center; padding-top: 15px; color: #7e7e7e;}
.money div{ width: 29%; height: 40px; border: 1px solid #ffa68b; margin: 5px; line-height: 40px; border-radius: 3px;}
.footer{ margin-top: 15px;}
.footer a{ text-decoration: none;}
.footer button{ width: 80%; margin-right: auto; margin-left: auto; background-color: #f00; color: #fff; display: block; border: 0; height: 40px; border-radius: 3px; font-size: 14px; font-family: Arial,"Microsoft YaHei";}
</style>



// WEBPACK FOOTER //
// src/pages/recharge/components/Mess.vue